/**
 * ts-form-ux.js — Améliorations UX du formulaire d'estimation
 * Fonctionne en complément de ts-valid-data.js sans le modifier.
 * Responsabilités : formatage des champs, compteur de caractères, animation pulse.
 * La validation, le spinner et le scroll vers erreur sont gérés par ts-valid-data.js.
 */
document.addEventListener("DOMContentLoaded", function () {

  // ── Formatage automatique du téléphone ─────────────────────────────────
  // ts-valid-data.js strip les non-digits avant validation — aucun conflit
  const phoneInput = document.getElementById("phone");
  if (phoneInput) {
    function formatPhone(raw) {
      let digits = raw.replace(/\D/g, "");
      // Retirer l'indicatif pays +1 / 1 (Canada/USA) si présent
      if (digits.length === 11 && digits.charAt(0) === "1") {
        digits = digits.slice(1);
      }
      digits = digits.substring(0, 10);
      if (digits.length >= 7) {
        return "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6);
      } else if (digits.length >= 4) {
        return "(" + digits.slice(0, 3) + ") " + digits.slice(3);
      } else if (digits.length > 0) {
        return "(" + digits;
      }
      return "";
    }

    phoneInput.addEventListener("input", function () {
      const cursorPos = this.selectionStart;
      const oldValue  = this.value;

      // Compter combien de chiffres il y avait avant le curseur
      let digitsBeforeCursor = 0;
      for (let i = 0; i < cursorPos; i++) {
        if (/\d/.test(oldValue[i])) digitsBeforeCursor++;
      }

      const formatted = formatPhone(oldValue);
      this.value = formatted;

      // Replacer le curseur après le Nième chiffre dans la chaîne formatée
      let count = 0;
      let newPos = formatted.length;
      for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) count++;
        if (count === digitsBeforeCursor) {
          newPos = i + 1;
          break;
        }
      }
      try { this.setSelectionRange(newPos, newPos); } catch (e) {}
    });

    // Gérer l'autocomplete navigateur (change + blur)
    phoneInput.addEventListener("change", function () {
      this.value = formatPhone(this.value);
    });
  }

  // ── Formatage automatique du code postal ───────────────────────────────
  const postalInput = document.getElementById("postalCode");
  if (postalInput) {
    postalInput.addEventListener("input", function () {
      let val = this.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
      if (val.length > 3) {
        val = val.slice(0, 3) + " " + val.slice(3, 6);
      }
      this.value = val;
    });
  }

  // ── Compteur de caractères pour le message ─────────────────────────────
  const messageField = document.getElementById("message");
  const MAX_CHARS = 500;
  if (messageField) {
    messageField.setAttribute("maxlength", MAX_CHARS);
    const counter = document.createElement("div");
    counter.className = "ts-char-counter";
    counter.textContent = "0 / " + MAX_CHARS;
    messageField.parentNode.insertBefore(counter, messageField.nextSibling);

    messageField.addEventListener("input", function () {
      const len = this.value.length;
      counter.textContent = len + " / " + MAX_CHARS;
      counter.classList.toggle("ts-char-counter--warn", len > MAX_CHARS * 0.85);
    });
  }

  // ── Animation pulse sur sélection d'un service ────────────────────────
  document.querySelectorAll(".ts-service-card-input").forEach(function (input) {
    input.addEventListener("change", function () {
      if (this.checked) {
        const label = this.nextElementSibling;
        if (label) {
          label.classList.remove("ts-service-card-label--pulse");
          void label.offsetWidth; // Force reflow pour relancer l'animation
          label.classList.add("ts-service-card-label--pulse");
          label.addEventListener("animationend", function () {
            label.classList.remove("ts-service-card-label--pulse");
          }, { once: true });
        }
      }
    });
  });

});
